import { render, staticRenderFns } from "./OthosRecording.vue?vue&type=template&id=583f644d&scoped=true"
import script from "./OthosRecording.vue?vue&type=script&lang=js"
export * from "./OthosRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583f644d",
  null
  
)

export default component.exports